<p-card styleClass="validations-card">
  <div class="page-header">
    <div class="header-left">
      <span class="page-icon is-primary"><i class="fa-solid fa-file-signature" aria-hidden="true"></i></span>
      <div>
        <h1>Validaciones de buró</h1>
        <p class="header-subtitle">
          Formatos con los que los clientes autorizan consultar su historial crediticio.
          <ng-container *ngIf="!canValidate">Solo Legal los aprueba o rechaza: aquí los ves en solo lectura.</ng-container>
        </p>
      </div>
    </div>
    <div class="header-right" role="group" aria-label="Filtrar por estado">
      <button
        *ngFor="let option of statuses"
        pButton
        type="button"
        class="p-button-sm"
        [class.p-button-outlined]="option.value !== status"
        [attr.aria-pressed]="option.value === status"
        [label]="option.label"
        (click)="setStatus(option.value)"
        [attr.data-test]="'tray-filter-' + option.value"
      ></button>
    </div>
  </div>

  <p-divider></p-divider>

  <div class="empty-state" *ngIf="loading" data-test="tray-loading">
    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
    <span>Cargando la bandeja…</span>
  </div>

  <div class="empty-state is-error" *ngIf="!loading && loadError" role="alert" data-test="tray-error">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    <h3>No pudimos cargar la bandeja</h3>
    <span>{{ loadError }}</span>
    <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-refresh" label="Reintentar" (click)="load()"></button>
  </div>

  <div class="empty-state" *ngIf="!loading && !loadError && !items.length" data-test="tray-empty">
    <i class="fa-solid fa-inbox" aria-hidden="true"></i>
    <h3>{{ status === 'pending' ? 'No hay formatos por validar' : 'No hay formatos en este estado' }}</h3>
  </div>

  <div class="table-wrap" *ngIf="!loading && !loadError && items.length">
    <table class="tray-table">
      <caption class="p-hidden-accessible">
        Formatos de autorización de buró: cliente, quién lo mandó, estado y archivo
      </caption>
      <thead>
        <tr>
          <th scope="col">Cliente</th>
          <th scope="col">Mandado</th>
          <th scope="col">Estado</th>
          <th scope="col">Archivo</th>
          <th scope="col"><span class="p-hidden-accessible">Acciones</span></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of items; trackBy: trackById" data-test="tray-row">
          <td>
            <span class="client-name">{{ item.clientSummary?.name || 'Cliente no disponible' }}</span>
            <span class="client-rfc">{{ item.clientSummary?.rfc }}</span>
          </td>
          <td>
            <span>{{ item.createdAt | mxDate }}</span>
            <span class="muted">{{ item.uploadedBy.name }}</span>
          </td>
          <td><p-tag [severity]="statusOf(item).severity" [icon]="statusOf(item).icon" [value]="statusOf(item).label"></p-tag></td>
          <td class="file">{{ item.documentName || 'Formato' }}</td>
          <td class="row-actions">
            <a
              pButton
              class="p-button-sm"
              [class.p-button-outlined]="!(canValidate && item.status === 'pending')"
              [icon]="canValidate && item.status === 'pending' ? 'pi pi-check-square' : 'pi pi-eye'"
              [label]="canValidate && item.status === 'pending' ? 'Validar' : 'Ver'"
              [routerLink]="['/credit-history/validations', item.id]"
              data-test="tray-open"
            ></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</p-card>
